// extracted by mini-css-extract-plugin
module.exports = {"body":"PanelStack__body___1Oygb","panel":"PanelStack__panel___v3b71"};